var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "", "full-height": _vm.modalFullHeight } },
    [
      _vm.extraPrintOptionsModalOpen
        ? _c("app-sale-print-extra-options-modal", {
            attrs: {
              "emit-instead-of-print": "",
              sale: _vm.sale,
              "default-context": _vm.salePrintContext,
            },
            on: {
              close: function ($event) {
                return _vm.closeSalePrintExtraOptionsModal()
              },
              files: _vm.onFiles,
            },
          })
        : _c(
            "app-send-message",
            {
              attrs: {
                disabled: !_vm.ready,
                attachements: _vm.attachements,
                content: _vm.content,
                "is-html": _vm.htmlSelected,
                "send-handler": _vm.sendHandler,
                subject: _vm.subject,
                to: _vm.clientMailAddress,
                bcc: _vm.extraBcc,
                "additional-bcc": _vm.additionalBcc,
                contacts: _vm.contacts,
                "mail-settings": _vm.defaultMailSettings,
              },
              on: {
                "update:isHtml": function ($event) {
                  _vm.htmlSelected = $event
                },
                "update:is-html": function ($event) {
                  _vm.htmlSelected = $event
                },
                close: _vm.close,
                sent: function ($event) {
                  return _vm.onSent($event)
                },
              },
            },
            [
              _c(
                "w-dropdown",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("tooltip.select-template"),
                      expression: "$ct('tooltip.select-template')",
                    },
                  ],
                  staticClass: "templates",
                  attrs: {
                    slot: "templates",
                    items: _vm.templateItems,
                    flat: "",
                    right: "",
                    "trigger-class": "light",
                    up: "",
                  },
                  on: { click: _vm.trigger },
                  slot: "templates",
                },
                [_c("w-fa", { attrs: { icon: "envelope-open-text" } })],
                1
              ),
              _vm.canUseReadNotifications()
                ? _c("w-checkbox", {
                    attrs: {
                      slot: "left-actions",
                      label: _vm.$ct("add-read-confirmation"),
                    },
                    slot: "left-actions",
                    model: {
                      value: _vm.addReadConfirm,
                      callback: function ($$v) {
                        _vm.addReadConfirm = $$v
                      },
                      expression: "addReadConfirm",
                    },
                  })
                : _vm._e(),
              _c(
                "template",
                { slot: "extra-actions" },
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("tooltip.download-document"),
                          expression: "$ct('tooltip.download-document')",
                        },
                      ],
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadDocument()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "download" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }